module.exports = __webpack_public_path__ + "static/product-detail-faq-1-b09416833155f1334ab3fef4bfbce0a1.jpeg";